<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    hide-overlay
    stateless
    app
    dark
    id="app-drawer"
  >
    <v-img src="/static/sidebar.jpg" height="100%">
      <v-layout fill-height column class="drawer__background">
        <v-list-tile avatar>
          <v-list-tile-avatar color="white">
            <v-img src="/static/male.jpg" height="34" contain />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{ $store.state.user.username }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini" >
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list dark class="drawer__list__background">
          <v-list-group
            v-if="!mini"
            v-for="(menu, key) in menus"
            :key="key"
            no-action
            :prepend-icon="getVuetifyIcon(key)"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="(item, i) in menu"
              v-if="i !== 'name'"
              :key="i"
              :to="{name: item.route, params: {lang: $route.params.lang}}"
            >
              <v-list-tile-action>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-tile-action>
              <v-list-tile-title v-text="item.name"></v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      drawer: true,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      mini: true,
      right: null
    }
  },
  computed: {
    menus () {
      return this.$t('Components.Toolbar')
    }
  },
  methods: {
    getVuetifyIcon (iconKey) {
      return `$vuetify.icons.${iconKey}`
    },
    dosomething (item) {
      console.log(item)
    }
  }
}
</script>

<style lang="scss" scoped>

#app-drawer {
  .drawer__background {
    background: rgba(27, 27, 27, 0.74);
  }

  .drawer__list__background {
    background: none;
    opacity: .9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationDrawer.vue